"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessageTags = exports.customerMessageTag = exports.channelIdTag = void 0;
exports.channelIdTag = 'ChannelId-lcw'; // Tag for PVA bot to return proper response for live chat channel
exports.customerMessageTag = 'FromCustomer'; // Tag to support transcript analytics feature
exports.defaultMessageTags = [exports.channelIdTag, exports.customerMessageTag];
//# sourceMappingURL=MessageTags.js.map